import { render, staticRenderFns } from "./UnlinkIcon.vue?vue&type=template&id=04fa3cf6&"
import script from "./UnlinkIcon.vue?vue&type=script&lang=js&"
export * from "./UnlinkIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports